import {
  YesNoField,
  TextField,
  TextAreaField,
  NumberField,
} from '@/components/ChecklistFields'

export interface ChecklistPreviewItem {
  id?: string
  type?: 'YesNo' | 'Text' | 'TextArea' | 'Number'
  label?: string
  isRequired?: boolean
}

interface ChecklistTemplatePreviewFieldsProps {
  items: ChecklistPreviewItem[]
}

export function ChecklistTemplatePreviewFields({
  items,
}: ChecklistTemplatePreviewFieldsProps) {
  if (items.length === 0) {
    return (
      <p className="text-sm text-content-primary-subtle py-8 text-center">
        This template has no fields.
      </p>
    )
  }

  return (
    <div className="flex flex-col gap-4 pb-8">
      {items.map((item, i) => {
        const key = item.id ?? i
        const common = {
          label: item.label || `Field ${i + 1}`,
          isRequired: item.isRequired ?? false,
          readOnly: true,
        }
        if (item.type === 'YesNo') {
          return <YesNoField key={key} {...common} value={null} />
        }
        if (item.type === 'TextArea') {
          return <TextAreaField key={key} {...common} value={null} />
        }
        if (item.type === 'Number') {
          return <NumberField key={key} {...common} value={null} />
        }
        return <TextField key={key} {...common} value={null} />
      })}
    </div>
  )
}
